import { render } from "./HeaderShare.vue?vue&type=template&id=94a032c6"
import script from "./HeaderShare.vue?vue&type=script&lang=js"
export * from "./HeaderShare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__